import {PartSelectableObjectChromoLogo} from "../partSelObChromoLogo";
import {PartPatternContainer} from "./partPatternContainer";
import {Vector2} from "../delme_globals";
import {VIEWERFEATURE} from "../debugMenu";
import DEBUG from "../DEBUG";
import {SelObTypes} from "../SelObTypes";
import type {PartSelObShaderInfoProvider} from "@k/js/shader/PartSelObShaderInfoProvider";



export class PartPattern extends PartSelectableObjectChromoLogo implements PartSelObShaderInfoProvider {
    private patternContainer: PartPatternContainer;

    public constructor(params) {
        super(params);
        this.patternContainer = params.patternContainer;
        this.textureSize = params.textureSize;
        // noinspection RedundantConditionalExpressionJS
        this.repeat = (DEBUG && VIEWERFEATURE.PATTERN_WITHOUT_REPEAT) ? false : true;
        this.insertTargetSize = params.insertTargetSize;
        this.type = SelObTypes.PATTERN;
    }

    public getTexture = () => this.texture;

    getMatrixAbsCanvasFromAbsUV() {
        return PartPatternContainer.createMatrixAbsCanvasFromAbsUV(
            this.scaling,
            this.getParent().partStauchungsFaktor,
            this.textureSize,
            this.translation
        );
    }

    createHandles() {
        return null;
    }

    placeAppropriateHandles() {
        return;
    }

    public setTargetSize(targetSize) {
        this.insertTargetSize = targetSize;
        this.scaling = this.getScalingForTargetSize();
    }

    private getScalingForTargetWidth():Vector2 {
        const pxProCmXAchse = this.parentDimensionInfos.textureSize.x / this.parentDimensionInfos.partSizeCM.x;
        const cmSelObWithoutScalingXAchse = this.getTextureSizeWithoutMargin("x") / pxProCmXAchse;
        const scale = (this.insertTargetSize / cmSelObWithoutScalingXAchse) / this.parentDimensionInfos.partStauchungsFaktor;
        return new Vector2(scale, scale);
    }

    public getScalingForTargetSize(): Vector2 {
        return this.getScalingForTargetWidth();
    }

    handlePartTransitionOnInsert() {
        return;
    }
}
